var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5586 12.8086L9.99609 1.40625C9.50391 0.558594 8.21875 0.53125 7.72656 1.40625L1.16406 12.8086C0.671875 13.6562 1.30078 14.75 2.3125 14.75H15.4102C16.4219 14.75 17.0508 13.6836 16.5586 12.8086ZM8.875 10.4297C9.55859 10.4297 10.1328 11.0039 10.1328 11.6875C10.1328 12.3984 9.55859 12.9453 8.875 12.9453C8.16406 12.9453 7.61719 12.3984 7.61719 11.6875C7.61719 11.0039 8.16406 10.4297 8.875 10.4297ZM7.67188 5.91797C7.64453 5.72656 7.80859 5.5625 8 5.5625H9.72266C9.91406 5.5625 10.0781 5.72656 10.0508 5.91797L9.85938 9.63672C9.83203 9.82812 9.69531 9.9375 9.53125 9.9375H8.19141C8.02734 9.9375 7.89062 9.82812 7.86328 9.63672L7.67188 5.91797Z",
    fill: "#B41400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangle);
export default __webpack_public_path__ + "static/media/exclamation-triangle.3844b61ea072149741c78f54a98849ef.svg";
export { ForwardRef as ReactComponent };